<script lang="ts">
  import { pageState, returnToDetails, returnToSearchPage } from "state/page";
  import SecondaryActionBar from "./SecondaryActionBar.svelte";
  import Detail from "./Detail/index.svelte";
  import Edit from "./Editor/Edit.svelte";
  import Jobs from "./Jobs/index.svelte";
  import FrontPage from "./Plugin/FrontPage.svelte";
  import SearchResults from "./SearchPage/SearchResults.svelte";
  import TopBar from "./TopBar.svelte";
  import Upload from "./Upload/Upload.svelte";
  import { onMount } from "svelte";
  import { productFruitsInstance } from "services/productFruitsService";
  import SideMenu from "./SideMenu.svelte";
  import Collections from "./Collections/index.svelte";
  import EditBottomActionBar from "./BottomActionBars/Edit.svelte";
  import { isPlugin } from "state/app";

  onMount(() => {
    $productFruitsInstance?.api.events.track(isPlugin ? "plugin-loaded" : "standalone-loaded");
  });

  let sideMenuState: "filters" | undefined;

  function toggleFilter() {
    sideMenuState = sideMenuState === "filters" ? undefined : "filters";
  }
</script>

<TopBar />
<main
  class:scrolling={$pageState.type === "COLLECTIONS" || $pageState.type === "JOBS"}
  class:editing={$pageState.type === "EDIT"}
>
  {#if $pageState.type === "LANDING_PAGE"}
    <FrontPage />
  {:else if $pageState.type === "JOBS"}
    <Jobs />
  {:else if $pageState.type === "COLLECTIONS"}
    <Collections sharedCollectionId={$pageState.sharedCollectionId} />
    <SecondaryActionBar />
  {:else if $pageState.type === "UPLOAD"}
    <Upload />
    {#if !isPlugin}
      <EditBottomActionBar />
    {/if}
  {:else if $pageState.type === "EDIT"}
    {#if isPlugin}
      {#key $pageState.itemIds}
        <Edit
          itemIds={$pageState.itemIds}
          onCancel={$pageState.itemIds.length === 1
            ? returnToDetails($pageState.itemIds)
            : returnToSearchPage}
          onDone={$pageState.itemIds.length === 1
            ? returnToDetails($pageState.itemIds)
            : returnToSearchPage}
        />
      {/key}
    {:else}
      <Edit
        itemIds={$pageState.itemIds}
        onCancel={returnToSearchPage}
        onDone={returnToSearchPage}
      />
      <EditBottomActionBar />
    {/if}
  {:else if $pageState.type === "DETAIL"}
    <Detail itemId={$pageState.itemId} itemSource={$pageState.itemSource ?? "Bildebanken"} />
  {:else}
    <!--height calc in css below can be read as (fullheight - header) -->
    <div style=" display:flex; flex-direction: row; height:calc(100vh - 50px);">
      <SideMenu bind:sideMenuState />
      <SearchResults filterOpen={sideMenuState === "filters"} {toggleFilter} />
    </div>
    <SecondaryActionBar />
  {/if}
</main>

<style>
  :root {
    background: black;
    overflow-y: hidden;
  }
  main {
    height: 100%;
    background: var(--color-surface-primary);
    min-height: 0; /* to move scrolling to images-container instead of whole page */
    position: relative;
  }

  main.editing {
    overflow: visible;
  }

  main.scrolling {
    overflow: auto;
  }
</style>
